import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-container users-page-container" }

import { onBeforeUnmount } from 'vue';
import { useRequestCancel } from '@/composables';
import UserHeader from './components/UserHeader';


export default /*@__PURE__*/_defineComponent({
  __name: 'Users',
  setup(__props) {

const requestCancel = useRequestCancel();

onBeforeUnmount(() => requestCancel.requestSaverAbortAll());

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(UserHeader)),
    _createVNode(_component_RouterView)
  ]))
}
}

})